import { useTranslation } from 'react-i18next';
import { Icon, Text } from '../../foundations';
import { VoucherValue } from './Voucher.model';
import styles from './Voucher.module.css';

export const VoucherSuccessMessage = (props: VoucherValue) => {
	const { t } = useTranslation(['voucher', 'common']);
	const { discount, remainingAmount, isRemainingAmountZero } = props;

	return (
		<div className={styles.box_input_message_box}>
			<div className={styles.box_input_icon_response}>
				<span className={styles.box_input_icon}>
					<Icon name="confirmacion" />
				</span>
				<Text as="span" font="verdana" className={styles.box_input_text}>
					{`${t('DISCCOUNT_TEXT')}: ${discount ?? ''}`}
				</Text>
			</div>

			{remainingAmount && remainingAmount.length > 0 && (
				<Text as="span" font="verdana" className={styles.box_input_subtext}>
					{isRemainingAmountZero ? t('ERROR_NO_AMOUNT') : `${t('SUCCESS_1')} ${remainingAmount} ${t('SUCCESS_2')}`}
				</Text>
			)}
		</div>
	);
};
